'use client'

import { useEffect, useMemo, useState } from 'react'
import { mergeQueryParams } from '@/lib/append-query-params'
import { IFRAME_ALLOW } from '@/lib/iframe-allow'

type CampaignIframeProps = {
  src: string
  title?: string
}

export function CampaignIframe({ src, title = 'Campaign iframe page' }: CampaignIframeProps) {
  const fallbackSrc = useMemo(() => mergeQueryParams(src), [src])
  const [mergedSrc, setMergedSrc] = useState(fallbackSrc)

  useEffect(() => {
    if (typeof window === 'undefined') return

    setMergedSrc(mergeQueryParams(src, window.location.search))
  }, [src])

  return (
    <main className="h-screen w-screen overflow-hidden">
      <iframe
        src={mergedSrc}
        title={title}
        className="h-full w-full border-0"
        allow={IFRAME_ALLOW}
      />
    </main>
  )
}
